import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import defaultImg from "./../../../images/task/img1.jpg";
import { var_api, image_api } from "../../../constant";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const WarehouseMaster = () => {
  const tableHeaders = [
    "#",
    "Image",
    "User",
    "Email",
    "Role",
    "Contact",
    "Status",
    "Action",
  ];
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: "",
    name: "",
    role: "",
    email_id: "",
    password: "",
    active_status: 1,
    remarks: "",
    contact_no1: "",
    whatsapp_no: "",
    contact_no2: "",
    profile_image: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const itemsPerPage = 10;
const [warehouseData, setWarehouseData] = useState([]);

  useEffect(() => {
    loadData();
    fetchWarehouseData();
  }, []);

  const loadData = async () => {
    try {
      setInitialLoading(true);
      const res = await axios.get(`${var_api}sa_veemart_warehouse_user_master/get`);
      setUserData(res.data || []);
    } catch {
      toast.error("Failed to fetch data");
    } finally {
      setInitialLoading(false);
    }
  };

const fetchWarehouseData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_warehouse_master/get`);
    setWarehouseData(res.data || []);
  } catch {
    toast.error("Failed to fetch warehouse data");
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: "",
      name: "",
      role: "",
      email_id: "",
      password: "",
      active_status: 1,
      remarks: "",
      contact_no1: "",
      whatsapp_no: "",
      contact_no2: "",
      profile_image: "",
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email_id.trim()) newErrors.email_id = "Email is required";
    if (!isEditMode && !formData.password.trim()) newErrors.password = "Password is required";

    const phoneRegex = /^[0-9]{10}$/;

  if (!formData.contact_no1.trim()) {
    newErrors.contact_no1 = "Contact No 1 is required";
  } else if (!phoneRegex.test(formData.contact_no1)) {
    newErrors.contact_no1 = "Contact No 1 must be exactly 10 digits";
  }

  if (formData.contact_no2 && !phoneRegex.test(formData.contact_no2)) {
    newErrors.contact_no2 = "Contact No 2 must be exactly 10 digits";
  }

  if (formData.whatsapp_no && !phoneRegex.test(formData.whatsapp_no)) {
    newErrors.whatsapp_no = "WhatsApp No must be exactly 10 digits";
  }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fill required fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      Object.entries(formData).forEach(([key, val]) => form.append(key, val));
      if (file) form.append("profile_image", file);
      const headers = { headers: { "Content-Type": "multipart/form-data" } };
      let res;
      if (isEditMode && formData.id)
        res = await axios.put(`${var_api}sa_veemart_warehouse_user_master/update/${formData.id}`, form, headers);
      else
        res = await axios.post(`${var_api}sa_veemart_warehouse_user_master/post`, form, headers);

      toast.success(res?.data?.message || "Saved successfully!");
      setShowModal(false);
      loadData();
    } catch {
      toast.error("Failed to save data");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = userData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={
                                item.profile_image
                                  ? `${image_api}${item.profile_image.replace(/^test\//, "")}`
                                  : defaultImg
                              }
                              alt="profile"
                              width="40"
                              height="40"
                              className="rounded"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                window.open(
                                  `${image_api}${item.profile_image.replace(/^test\//, "")}`,
                                  "_blank"
                                )
                              }
                            />
                          </td>
                          <td>{item.name}</td>
                          <td>{item.email_id}</td>
                          <td>{item.role}</td>
                          <td>{item.contact_no1}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.active_status === 1 ? "bg-success" : "bg-danger"
                              }`}
                            >
                              {item.active_status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit User" : "Add User"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                 <Form.Group className="mb-3">
  <Form.Label>Warehouse <span className="text-danger">*</span></Form.Label>
  <Select
    options={warehouseData.map((wh) => ({
      value: wh.id,
      label: `${wh.warehouse_name} (${wh.warehouse_no})`,
    }))}
    value={
      warehouseData
        .map((wh) => ({
          value: wh.id,
          label: `${wh.warehouse_name} (${wh.warehouse_no})`,
        }))
        .find((opt) => opt.value === formData.warehouse_id) || null
    }
    onChange={(selected) =>
      setFormData((prev) => ({ ...prev, warehouse_id: selected?.value || "" }))
    }
    placeholder="Select warehouse..."
    isSearchable
  />
</Form.Group>

                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter name"
                    />
                    {errors.name && <div className="text-danger small">{errors.name}</div>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Role</Form.Label>
                    <Form.Control
                      type="text"
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}
                      placeholder="Enter role"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="email_id"
                      value={formData.email_id}
                      onChange={handleInputChange}
                      placeholder="Enter email"
                    />
                    {errors.email_id && <div className="text-danger small">{errors.email_id}</div>}
                  </Form.Group>
                </Col>
                {!isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={passwordVisible ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Enter password"
                        />
                        <Button
                          variant="outline-secondary"
                          onClick={() => setPasswordVisible(!passwordVisible)}
                        >
                          {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                        </Button>
                      </InputGroup>
                      {errors.password && <div className="text-danger small">{errors.password}</div>}
                    </Form.Group>
                  </Col>
                )}
                <Col md={6}>
                 <Form.Group className="mb-3">
  <Form.Label>Contact No 1 <span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="contact_no1"
    value={formData.contact_no1}
    onChange={handleInputChange}
    placeholder="Enter contact number"
  />
  {errors.contact_no1 && <div className="text-danger small">{errors.contact_no1}</div>}
</Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3">
  <Form.Label>WhatsApp No</Form.Label>
  <Form.Control
    type="text"
    name="whatsapp_no"
    value={formData.whatsapp_no}
    onChange={handleInputChange}
    placeholder="Enter WhatsApp number"
  />
  {errors.whatsapp_no && <div className="text-danger small">{errors.whatsapp_no}</div>}
</Form.Group>
                </Col>
                <Col md={6}>
                 <Form.Group className="mb-3">
  <Form.Label>Contact No 2</Form.Label>
  <Form.Control
    type="text"
    name="contact_no2"
    value={formData.contact_no2}
    onChange={handleInputChange}
    placeholder="Enter secondary contact"
  />
  {errors.contact_no2 && <div className="text-danger small">{errors.contact_no2}</div>}
</Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="remarks"
                      value={formData.remarks}
                      onChange={handleInputChange}
                      placeholder="Enter remarks"
                    />
                  </Form.Group>
                </Col>
              {isEditMode && (
                            <Col md={6}>
                              <Form.Group className="mb-2 d-flex align-items-center gap-2">
                                <Form.Label className="mb-0">
                                  {formData.active_status === 1 ? "Active" : "Inactive"}
                                </Form.Label>
                                <Form.Check
                                  type="switch"
                                  id="active-status-switch"
                                  checked={formData.active_status === 1}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      active_status: e.target.checked ? 1 : 0,
                                    })
                                  }
                                  className={formData.active_status === 1 ? "custom-switch-green" : ""}
                                />
                              </Form.Group>
                            </Col>
                          )}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Profile Image</Form.Label>
                    {isEditMode && formData.profile_image && !file && (
                      <div className="mb-2 d-flex align-items-center gap-2">
                        <img
                          src={`${image_api}${formData.profile_image.replace(/^test\//, "")}`}
                          alt="Preview"
                          width="80"
                          className="rounded border"
                        />
                      </div>
                    )}
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Form.Group>
                </Col>
              </Row>
                       <div className="d-flex justify-content-end gap-2">
            {!isEditMode ? (
              <>
                <Button variant="secondary" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Creating...
                    </>
                  ) : (
                    "Create"
                  )}
                </Button>
                <Button
                  variant="danger"
                  type="reset"
                  disabled={loading}
                onClick={() =>
            setFormData({
              id: null,
      warehouse_id: "",
      name: "",
      role: "",
      email_id: "",
      password: "",
      active_status: 1,
      remarks: "",
      contact_no1: "",
      whatsapp_no: "",
      contact_no2: "",
      profile_image: "",
            })
          }
          
                >
                  Reset
                </Button>
              </>
            ) : (
              <>
                <Button variant="warning" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </Button>
                <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                  Cancel
                </Button>
              </>
            )}
          </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>
       <style>{`
  .custom-switch-green .form-check-input:checked {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  .custom-switch-red .form-check-input {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
  }
`}</style>
      <ToastContainer />
    </>
  );
};

export default WarehouseMaster;
